<template>

  <!--
      作者 luoyiming
      时间：2020-06-09
      描述：会员-项目管理-编辑标签
  -->
  <el-dialog title="审核" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false" :close-on-press-escape="false" width="600px">
    <el-form size="small" :model="form1" ref="form1">
      <el-form-item label="是否同意" :label-width="formLabelWidth" prop="audit_status" :rules="[{ required: true, message: ' ' }]">
        <el-switch :active-value="10" :inactive-value="20" v-model="form1.audit_status" active-color="#13ce66" inactive-color="#ff4949">
        </el-switch>
      </el-form-item>
      <el-form-item label="审核意见" :label-width="formLabelWidth" prop="audit_remark">
        <el-input v-model="form1.audit_remark" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="editGrade" :disabled="submit_loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import PorductApi from "@/api/product.js";
export default {
  data() {
    return {
      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      dialogVisible: false,
      /*是否正在提交*/
      submit_loading: false,
      form1: {
        audit_status: 10,
        audit_remark: "",
        product_id: ""
      }
    };
  },
  props: ["open_agree", "form"],
  created() {
    this.dialogVisible = this.open_agree;
    this.form1.product_id = this.form.product_id;
    this.form1.audit_status = this.form.audit_status;
    this.form1.audit_remark = this.form.audit_remark;
  },
  methods: {
    /*修改用户*/
    editGrade() {
      let self = this;
      let params = this.form1;
      self.$refs.form1.validate(valid => {
        if (valid) {
          self.submit_loading = true;
          PorductApi.auditProductstate(params, true)
            .then(data => {
              self.submit_loading = false;
              self.$message({
                message: "恭喜你，审核成功",
                type: "success"
              });
              self.dialogFormVisible(true);
            })
            .catch(error => {
              self.submit_loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/serviceagree/part/agree.vue